import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen pb-24 pt-48">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-24 pt-12">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative overflow-hidden rounded-2xl md:rounded-[2rem] aspect-[4/3]"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_bee-harvest-6/artifacts/qzercvc6_Boy%20Beekeeper%20Scene%20%281%29.jpg"
              alt="Beekeeper inspecting honeycomb"
              className="w-full h-full object-cover"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex flex-col justify-center space-y-6"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-foreground" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Our Story
            </h2>
            <p className="text-foreground/70 leading-relaxed">
              Ricky's Bees was born from a simple belief: honey should taste like honey. Pure, unprocessed and true to its source.
            </p>
            <p className="text-foreground/70 leading-relaxed">
              Based in Victoria, we partner with local landscapes to produce single-origin, small-batch honey. Each jar captures a unique time, place and bloom.
            </p>
            <p className="text-foreground/70 leading-relaxed">
              We don't blend. We don't heat-treat. We don't add anything. What you get is exactly what the bees made.
            </p>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-2xl md:rounded-[2rem] mb-24"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_bee-harvest-6/artifacts/vq302qsh_RICKY%20HERO%20SHOT%20HIGH%20RES.jpg"
            alt="Ricky the young beekeeper"
            className="w-full h-auto object-cover rounded-2xl md:rounded-[2rem]"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-2xl md:rounded-[2rem] aspect-[4/3] mb-24"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_bee-harvest-6/artifacts/95u029za_image.jpeg"
            alt="Beekeeper in Victoria with beehives"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 flex items-end">
            <div className="p-8 md:p-12">
              <h3 className="text-3xl md:text-4xl font-bold mb-2 text-white drop-shadow-lg" style={{ fontFamily: 'Outfit, sans-serif' }}>Victoria</h3>
              <p className="text-base md:text-lg text-white drop-shadow-lg">Where our bees call home</p>
            </div>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {[
            {
              title: 'Confident but calm',
              description: 'We know our honey is exceptional, but we let it speak for itself.'
            },
            {
              title: 'Premium but not pretentious',
              description: 'High quality doesn\'t mean complicated. Simple is better.'
            },
            {
              title: 'Local and traceable',
              description: 'Every jar can be traced back to its source. No mysteries, no blends.'
            }
          ].map((value, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="p-8 rounded-2xl bg-muted/30 border border-border"
              data-testid={`value-${index}`}
            >
              <h3 className="text-xl font-semibold text-foreground mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
                {value.title}
              </h3>
              <p className="text-foreground/70 text-sm leading-relaxed">
                {value.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default About;
